import { render, staticRenderFns } from "./ExerciseAnswerEntity.vue?vue&type=template&id=1003f41a&scoped=true"
import script from "./ExerciseAnswerEntity.vue?vue&type=script&lang=js"
export * from "./ExerciseAnswerEntity.vue?vue&type=script&lang=js"
import style0 from "./ExerciseAnswerEntity.vue?vue&type=style&index=0&id=1003f41a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003f41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1003f41a')) {
      api.createRecord('1003f41a', component.options)
    } else {
      api.reload('1003f41a', component.options)
    }
    module.hot.accept("./ExerciseAnswerEntity.vue?vue&type=template&id=1003f41a&scoped=true", function () {
      api.rerender('1003f41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExerciseAnswerEntity.vue"
export default component.exports